module.exports = __webpack_public_path__ + "img/9.b179225c.jpg";